import { render, staticRenderFns } from "./VerDetalleSimSolicitudes.vue?vue&type=template&id=9b4586d2&scoped=true&"
import script from "./VerDetalleSimSolicitudes.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleSimSolicitudes.vue?vue&type=script&lang=ts&"
import style0 from "./VerDetalleSimSolicitudes.vue?vue&type=style&index=0&id=9b4586d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4586d2",
  null
  
)

export default component.exports